import { assign, has, isEmpty } from 'lodash';
import { addFilter } from '@wordpress/hooks';
import { createHigherOrderComponent } from '@wordpress/compose';
import { Fragment, useEffect } from '@wordpress/element';
import { InspectorAdvancedControls } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import PaddingControl from '../../extensions/controls/padding-control';
import MarginControl from '../../extensions/controls/margin-control';
import { updateBlockStyle } from './inline-styles';

// Enable Responsive disply control on the following blocks
const enabledBlocks = [
	// 'core/button',
	// 'core/buttons',
	// 'core/group',
	'gutenify/gallery-carousel',
	'gutenify/map',
	'gutenify/container',
	'gutenify/buttons',
	'gutenify/button',
	'gutenify/icon',
	'gutenify/info-box',
	'gutenify/service',
	'gutenify/section-title',
	'gutenify/star-rating',
	'gutenify/testimonial',
	'gutenify/testimonials',
	'gutenify/team-member',
	'gutenify/team',
	'gutenify/post-carousel',
	// 'gutenify/slide-item',
];

const addAttributes = ( settings, name ) => {
	// Do nothing if it's another block than our defined ones.
	if ( ! enabledBlocks.includes( name ) ) {
		return settings;
	}

	if ( ! has( settings, 'attributes.blockAdvanceOptions' ) ) {
		// Use Lodash's assign to gracefully handle if attributes are undefined
		settings.attributes = assign( settings.attributes, {
			blockAdvanceOptions: {
				type: 'object',
				default: [],
			},
		} );
	}

	// if ( ! has( settings, 'attributes.blockClientId' ) ) {
	// 	// Use Lodash's assign to gracefully handle if attributes are undefined
	// 	settings.attributes = assign( settings.attributes, {
	// 		blockClientId: {
	// 			type: 'string',
	// 			default: '',
	// 		},
	// 	} );
	// }

	return settings;
};

addFilter(
	'blocks.registerBlockType',
	'extend-block-example/attribute/spacing',
	addAttributes
);

/**
 * Create HOC to add spacing control to inspector controls of block.
 */
const withSpacingControl = createHigherOrderComponent( ( BlockEdit ) => {
	return ( props ) => {
		// Do nothing if it's another block than our defined ones.
		if ( ! enabledBlocks.includes( props.name ) ) {
			return <BlockEdit { ...props } />;
		}

		useEffect( () => {
			updateBlockStyle( {}, props );
		}, [] );

		const updateStyle = ( data ) => {
			updateBlockStyle( data, props );
		};

		const { className } = props.attributes;

		if ( isEmpty( className ) ) {
			props.attributes.className = '';
		}
		return (
			<Fragment>
				<BlockEdit { ...props } />
				<InspectorAdvancedControls>
					<PaddingControl
						{ ...props }
						parentKey="blockAdvanceOptions"
						label={ __( 'Padding' ) }
						property="padding"
						onChange={ updateStyle }
					/>
					<MarginControl
						{ ...props }
						parentKey="blockAdvanceOptions"
						label={ __( 'Margin' ) }
						onChange={ updateStyle }
					/>
				</InspectorAdvancedControls>
			</Fragment>
		);
	};
}, 'withSpacingControl' );

addFilter(
	'editor.BlockEdit',
	'extend-block-example/with-spacing-control',
	withSpacingControl
);

// const addSpacingExtraProps = ( saveElementProps, blockType, attributes ) => {
// 	// Do nothing if it's another block than our defined ones.
// 	if ( ! enabledBlocks.includes( blockType.name ) ) {
// 		return saveElementProps;
// 	}

// 	// assign( saveElementProps, {
// 	// 	'data-section': `gutenify-section-${ attributes.blockClientId }`,
// 	// } );

// 	saveElementProps.className =
// 		saveElementProps.className +
// 		` gutenify-section-${ attributes.blockClientId }`;

// 	return saveElementProps;
// };

// addFilter(
// 	'blocks.getSaveContent.extraProps',
// 	'extend-block-example/get-save-content/extra-props',
// 	addSpacingExtraProps
// );
